export default __webpack_public_path__ + "static/media/rating-review.83a2d13c.svg";